import { useEffect, useState } from "react";

import { decoColumns } from "./misc/deco-columns";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const useLifecycle = () => {
    const { platformId } = useParams();      
    const { axiosInstance, loading, cancelAllRequests } = useAxios({ base: "panel", initialLoader: true });
    const { getSearchParams  } = useSearchParams();
    const [data, setData] = useState({ lifecycle: [], pagination: {} });
    const [queryParams, setQueryParams] = useState({});
    const [modalConfig, setModalConfig] = useState({ isOpen: false, row: {} });
    const handleModalConfig = (row = {}) => {
        setModalConfig((prev) => ({ row, isOpen: !prev.isOpen }));
    };
    const getLifecycle = async () => {
        const { data } = await axiosInstance.get(`/lifecycle/${platformId}`, {
            params: {
                page : getSearchParams("page"),
                limit: getSearchParams("limit")
            }
        });
        setData({
            lifecycle : data || [],
            pagination: data.pagination || {}
        });
     
    };
    
    const handleRowActions = async (row = {}, action) => {
        if (action === "delete") {
            await axiosInstance.delete(`/lifecycle/${platformId}/${row._id}`);
            getLifecycle();
            return;
        } 
        handleModalConfig(row);
        
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getLifecycle();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);
    return {
        data,
        loading,
        columns: decoColumns({ handleRowActions }),
        modalConfig,
        getLifecycle,
        setQueryParams,
        handleModalConfig
    };
  
};

export default useLifecycle;